import { useEffect, useState } from 'react';

import * as Teams from '@microsoft/teams-js';
import {
	Provider,
	mergeThemes,
	teamsTheme,
	teamsDarkTheme,
	teamsHighContrastTheme
} from '@fluentui/react-northstar';
import { app } from '@microsoft/teams-js';

/**
 * Theme toggler provider
 */
export default function Theme({ children }: React.PropsWithChildren<unknown>) {
	const themes: { [index: string]: any } = {
		default: teamsTheme,
		dark: teamsDarkTheme,
		contrast: teamsHighContrastTheme
	};

	const [theme, setTheme] = useState('default');

	useEffect(() => {
		const initializeTeams = async () => {
			try {
				// Initialize the Teams app
				await app.initialize();

				// Get the initial context (includes theme)
				const context = await app.getContext();

				if (context.app.theme) {
					setTheme(context.app.theme);
				}

				// Register theme change handler
				app.registerOnThemeChangeHandler(theme => {
					setTheme(theme);
				});

				// Notify that app initialization is complete
				app.notifySuccess();
			} catch (error) {
				app.notifyFailure({
					reason: app.FailedReason.Other,
					message:
						error instanceof Error
							? error.message
							: 'Initialization failed'
				});
			}
		};

		initializeTeams();
	}, []);

	const customizedTheme = mergeThemes(themes[theme], {
		siteVariables: {
			bodyBackground: 'transparent'
		}
	});

	return <Provider theme={customizedTheme}>{children}</Provider>;
}
